import { render } from "./TabGroup.vue?vue&type=template&id=42ebc0de"
import script from "./TabGroup.vue?vue&type=script&lang=js"
export * from "./TabGroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/martinflores/Documents/kitsuu-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__